module.exports = __webpack_public_path__ + "img/兴业银行.966aadc4.png";